import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  SelectField,
  TextInputField,
} from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useUser from '../../../hooks/user/useAdminUser';
import {
  AdminUserDataType,
  AdminUserInitialValues,
  AdminUserSchema,
  IAdminUserRequest,
} from '../../../models/user/adminUser.model';
import { getAdminRoles } from '../../../utils/utils';

const CreateAdminUserModal = () => {
  const { createUser, loading } = useUser();

  const onSubmit = (values: AdminUserDataType, actions: any) => {
    const data: IAdminUserRequest = {
      ...values,
      role: getAdminRoles(values.role),
      phoneNumber: '234' + values.phoneNumber.slice(1),
    };

    createUser(data);

    // if (resetInputFields) {
    actions.resetForm(AdminUserInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Create Admin'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={AdminUserInitialValues}
          schema={AdminUserSchema}
          onSubmit={onSubmit}
        >
          <TextInputField
            label="Phone No"
            name="phoneNumber"
            type="text"
            placeholder="Phone Number"
            className="full"
          />

          <TextInputField
            label="Email"
            name="email"
            type="email"
            placeholder="Email"
            className="full"
          />
          <TextInputField
            label="First Name"
            name="firstName"
            type="text"
            placeholder="First Name"
            className="full"
          />

          <TextInputField
            label="Last Name"
            name="lastName"
            type="text"
            placeholder="Last Name"
            className="full"
          />

          <SelectField label="Role" name="role">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Role'}
            </option>
            <option>Admin</option>
            <option>Super Admin</option>
          </SelectField>

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Create User
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default CreateAdminUserModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
